import { Navbar } from "@/components/landing/Navbar";
import { Pricing as PricingSection } from "@/components/landing/Pricing";
import { FAQ } from "@/components/landing/FAQ";
import { Footer } from "@/components/landing/Footer";
import { ScrollProgress, WhatsAppFab } from "@/components/landing/Floating";
import SEO from "@/components/SEO";
import { getFAQPageSchema } from "@/lib/seoSchemas";
import { FAQS } from "@/lib/data";

export default function PricingPage() {
  return (
    <div className="relative min-h-screen bg-white font-sans text-navy-900 antialiased" data-testid="pricing-page">
      <SEO
        title="Transparent Pricing Plans for Business Registration & Compliance | Biz360"
        description="Affordable, transparent pricing plans for business incorporation, GST filing, corporate ROC compliance and accounting. No hidden fees."
        canonical="/pricing"
        keywords="compliance pricing India, company registration cost, GST filing fees Pune, corporate secretarial charges"
        breadcrumbs={[{ label: "Pricing", href: "/pricing" }]}
        schema={getFAQPageSchema(FAQS)}
      />
      <ScrollProgress />
      <Navbar />
      <main className="pt-20 md:pt-24">
        <PricingSection />
        <FAQ />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
